export const mobileNavLinks = [
  {
    id: 1,
    linkTo: '/search',
    icon: 'search',
  },
  {
    id: 2,
    linkTo: '/videos',
    icon: 'movie_creation',
  },
  {
    id: 3,
    linkTo: '/',
    icon: 'home',
  },
  {
    id: 4,
    linkTo: '/profile',
    icon: 'person',
  },
];
